/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { findManyEstateFeatures } from '../../lib/rest/estateFeatureAPIClient'
import { getHalEmbedded } from '@jalik/hal'
import { useQuery } from '@tanstack/react-query'
import { parseNumber } from '@jalik/form-parser'
import { Checkbox, SimpleGrid } from '@mantine/core'
import { useFormContext } from '@jalik/react-form'

function EstateFeaturesField () {
  const form = useFormContext()
  const listQuery = useQuery({
    enabled: true,
    queryKey: ['estateFeatures'],
    queryFn: () => findManyEstateFeatures({ limit: 100 })
  })

  const features = useMemo(() => (
    (listQuery.data != null
      ? getHalEmbedded(listQuery.data)?.estateFeatures
      : null) || []
  ), [listQuery.data])

  return (
    <Checkbox.Group
      {...form.getFieldProps('features')}
      onChange={(value) => {
        form.setValue('features', (value ?? []).map((el) =>
          typeof el === 'string' ? parseNumber(el) : el))
      }}
      // convert values to String to make CheckboxGroup working
      value={form.getValue('features', []).map(String)}
    >
      <SimpleGrid cols={{ sm: 2, xl: 4 }} verticalSpacing="xs">
        {features.map((feature) => (
          <Checkbox
            key={feature.id}
            label={feature.name}
            type="checkbox"
            value={String(feature.id)}
          />
        ))}
      </SimpleGrid>
    </Checkbox.Group>
  )
}

export default EstateFeaturesField
